import React, { useState } from 'react';
import { TextField, Button, Grid, Container } from '@mui/material';
import Footer from '../Partial/footer/footer';
import Navbar from '../Partial/navbar/Navbar';
import dragonBridge from '../../assets/images/dragonBridge.jpg';
import './supportPage.css';

import { useTranslation } from 'react-i18next';
import '../../i18n';

import {sendEmail} from './formEmail'; // Import the sendEmail function

const SupportPage = () => {
  const { t } = useTranslation();

  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    sendEmail(form)
      .then(() => {
        setStatus('Message sent successfully!');
        setForm({ name: '', email: '', message: '' });
      }, () => {
        setStatus('Failed to send message. Please try again.');
      })
      .finally(() => setLoading(false));
  };

  return (
    <Container maxWidth={false} disableGutters>
      <Navbar />
      <div className="support-container">
        <div className="image-container">
          <img src={dragonBridge} alt="support" className="support-image" />
          <div className="support-text">
            <h3>{t('navigation:supportPage-title')}</h3>
          </div>
        </div>
        {/* Material UI Contact Form */}
        <div className="container-fluid">
        <div className="contact-form">
          <h2>{t('navigation:form')}</h2>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="Your Name"
                  name="name"
                  fullWidth
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Your Email"
                  name="email"
                  type="email"
                  fullWidth
                  value={form.email}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Your Message"
                  name="message"
                  fullWidth
                  multiline
                  rows={4}
                  value={form.message}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <Button type="submit" variant="contained" color="primary" disabled={loading}>
                  {loading ? 'Sending...' : 'Send'}
                </Button>
              </Grid>
            </Grid>
          </form>
          {status && <p>{status}</p>}
        </div>
        </div>
      </div>
      <div className="contact-info">
        <h2>{t('navigation:contact')}</h2>
        <ul>
          <li>Email: Dreamers.Journey09@gmail.com</li>
          <li>{t('navigation:footer.phoneNumber')}: +84 39 620 7199</li>
          <a style={{ textDecoration: 'none' }} href="https://www.facebook.com/profile.php?id=61567331845801">
            <li>Facebook: The Dreamer's Journey</li>
           </a>
          <a style={{ textDecoration: 'none' }} href="https://www.instagram.com/dreamers.journey09"><li>Instagram: dreamers.journey09</li></a>
          <a style={{ textDecoration: 'none' }} href="https://www.tiktok.com/@dreamers.journey"><li>Tiktok: @dreamers.journey</li></a>
          <a style={{ textDecoration: 'none' }} href="https://www.pinterest.com/dreamersjourney09/"><li>Pinterest: dreamersjourney09</li></a>
        </ul>
      </div>
      <Footer />
    </Container>
  );
};

export default SupportPage;